import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "@id": "https://allchinabuy.art/about#aboutpage",
  "url": "https://allchinabuy.art/about",
  "name": "About Us — allchinabuy.art",
  "description": "allchinabuy.art is an independent community resource dedicated to helping shoppers discover the best AllChinaBuy Spreadsheet finds with verified, community-backed recommendations.",
  "inLanguage": "en-US",
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://allchinabuy.art/#website",
    "url": "https://allchinabuy.art/",
    "name": "allchinabuy.art"
  },
  "about": {
    "@type": "Organization",
    "name": "allchinabuy.art",
    "url": "https://allchinabuy.art/",
    "description": "Independent community resource for AllChinaBuy Spreadsheet verified finds and shopping guides."
  },
  "dateModified": "2026-06-25"
};

export default function About() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      {/* Schema.org BreadcrumbList */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://allchinabuy.art/" },
              { "@type": "ListItem", "position": 2, "name": "About Us", "item": "https://allchinabuy.art/about" }
            ]
          }),
        }}
      />
      <Navbar />
      <main>
        <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 transition-colors mb-6 cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">About Us</h1>
            <div className="prose prose-sm md:prose-base max-w-none text-foreground-600 leading-relaxed space-y-4">
              <p>
                allchinabuy.art is an independent community resource dedicated to helping shoppers discover the best AllChinaBuy Spreadsheet finds. Our mission is to provide verified, community-backed product recommendations, QC guides, and shopping tutorials — all freely accessible to everyone.
              </p>
              <p>
                We are not affiliated with any seller or marketplace. Our recommendations are based solely on community feedback and rigorous quality verification. Every product featured in our spreadsheet has been tested and reviewed by real community members.
              </p>
              <p>
                Our editorial team works tirelessly to keep the AllChinaBuy Spreadsheet updated on a weekly basis, ensuring that every link, every QC photo reference, and every seller rating reflects the most current information available. We believe that transparent, community-driven curation is the best way to help shoppers make informed decisions.
              </p>
              <p>
                Whether you are a first-time shopper looking for guidance or an experienced buyer searching for the latest verified finds, allchinabuy.art is here to support your journey. Explore our complete <Link to="/best-allchinabuy-spreadsheet" className="text-primary-500 hover:text-primary-600 font-medium cursor-pointer">AllChinaBuy Spreadsheet Guide</Link> to get started.
              </p>
            </div>
            <nav className="mt-8 text-xs text-foreground-400" aria-label="Breadcrumb">
              <ol className="flex items-center gap-2 flex-wrap">
                <li><Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">Home</Link></li>
                <li><i className="ri-arrow-right-s-line text-[10px]"></i></li>
                <li className="text-foreground-600">About Us</li>
              </ol>
            </nav>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}